import React from "react";

const UpscCalenderMain = () => {
  const REFER_URL = "https://upsc.gov.in/examinations/active-exams";
  return (
    <div className="container my-5" style={{ paddingBottom: "70px" }}>
      <div className="table-responsive">
        <table className="table table-bordered table-striped">
          <thead className="thead-dark">
            <tr>
              <th>#</th>
              <th>Announcement</th>
              <th>Date</th>
              <th>Details</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td>
                UPSC Civil Services Examination 2025 Notification Released
              </td>
              <td>January 22, 2025</td>
              <td>
                <a
                  href={REFER_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View Details
                </a>
              </td>
            </tr>
            <tr>
              <td>2</td>
              <td>Application Period for UPSC CSE 2025</td>
              <td>Jan 22 - Feb 11, 2025</td>
              <td>
                <a
                  href={REFER_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View Details
                </a>
              </td>
            </tr>
            <tr>
              <td>3</td>
              <td>UPSC CSE 2025 Preliminary Exam Date Announced</td>
              <td>May 25, 2025</td>
              <td>
                <a
                  href={REFER_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View Details
                </a>
              </td>
            </tr>
            <tr>
              <td>4</td>
              <td>UPSC CSE 2025 Main Examination Dates</td>
              <td>August 22, 2025</td>
              <td>
                <a
                  href={REFER_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View Details
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default UpscCalenderMain;
